import { populationText } from "./population.ts";

export interface About { capital: string[]; population: number; languages: string[]; currency: string }

export function aboutFacts(a: About): [string, string][] {
  return [["Capital", a.capital.join(", ")], ["Population", populationText(a.population)], ["Languages", a.languages.join(", ")], ["Currency", a.currency]];
}
